import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { WithStyles, createStyles, Grid, Typography, Theme } from '@material-ui/core';
import { connect } from 'react-redux';
import { showVideoModal } from '../../../../../mylibrary/actions/showVideoProgressActions';
import { CloseOutlined as CloseIcon } from "@material-ui/icons";

const styles = (theme: Theme) =>
  createStyles({
    itemContainer: {
      display: 'flex',
      position: "relative",
      border: "1px solid #d8d8d8",
      borderRadius: "4px",
      padding: '12px',
      margin: '16px ​0px 0px 0px'
    },
     closeIcon: {
      top:-8,
    right:-8,
    cursor: "pointer",
    position: "absolute",
    background: "rgb(255 255 255)",
    border: "1px solid rgb(102 102 102)",
    borderRadius: "50%",
    },
    fileTypeInfo: {
      fontSize: 18,
      fontWeight: 600,
      color: '#666',
      textAlign: 'center',
    },
    dashedBorder: {
      border: 'dashed 1px #000',
      padding: 8,
      borderRadius: 4,
    },

    dashedBlock: {
      width: 600,
      margin: 20,
      height: 240,
    },

    fontSize2X: {
      fontSize: 15,
    },
    lineHeight2X: {
      lineHeight: 20,
    },

    typographyStyle: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '15px',
      lineHeight: '20px',
      width: '100%',
    },

    modal: {
      display: 'flex',
      padding: 12,
      alignItems: 'center',
      justifyContent: 'center',
    },

    modalHeader: {
      height: 60,
      borderBottom: 'solid 1px #0004',
    },

    subHeadingFont: {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 'bold',
    },

    margin1X: {
      margin: '6px',
    },
    buttonRoundBorder: {
      borderRadius: 0,
    },
    cardContent: {
      overflow: 'hidden',
    },
    dragDropVideoContainer: {
      border: 'dashed 1px #999',
      padding: '15px',
      textAlign: 'center',
      borderRadius: '5px',
      width: '170px',
    },
    dragDropVideoText: {
      color: '#a9a9a9',
      fontSize: '14px',
      fontWeight: 'normal',
      width: '140px',
      lineHeight: '18.2px',
      display: 'inline-block',
    },
      uploadPreview:{
        '&>:first-child':{
          justifyContent: 'center',
          '&>:first-child':{
            '&>:first-child':{
              margin: '16px 0'
            }
          }
        }
      },
       fileName: {
      fontSize: "14px",
      color: "#333",
      fontWeight: "bold",
      maxWidth: 150,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    extension: {
      textTransform: "uppercase",
      fontSize: "12px",
      color: "#999",
    },
  });

interface MathPixDataInterface {
  confidence: number;
  confidenceRate: number;
  text: string;
  html: string;
}

//@ts-ignore
interface FileUploaderProps extends WithStyles<typeof styles> {
  classes: any;
  showVideoModal: Function;
  handleVideoSelect: Function;
  videoUploadHandler: Function;
}
interface FileUploaderState {
  isUpload: boolean;
  uploadImage: string;
  isOpenUploadDialog: boolean;
  completed: number;
  zoomIcon: boolean;
  mathPixData: null | MathPixDataInterface;
  image: any;
  showZoomIcon: boolean;
  isCopied: boolean;
  fileName: string;
  extension: string;
}

class FileUploader extends Component<FileUploaderProps, FileUploaderState> {
  upload: any = null;
  textarea: any = null;
  isOpenUploadDialog: boolean = false;
  inputForPaste: any = null;
  wrapperRef: any = null;

  constructor(props: FileUploaderProps) {
    super(props);
    this.state = {
      isUpload: false,
      uploadImage: "/assets/svg/learn/cloudUpload.svg",
      isOpenUploadDialog: false,
      completed: 0,
      zoomIcon: false,
      mathPixData: null,
      image: null,
      showZoomIcon: false,
      isCopied: false,
      fileName: '',
      extension:''
    };
  }

  readFile = (event: any) => {
    const { videoUploadHandler } = this.props;
    let file: any = null;
    if (event.target.files) {
      file = event.target.files[0];
    }
    //On Drop
    if (event.dataTransfer && event.dataTransfer.files) {
      file = event.dataTransfer.files[0];
    }
    const extension = file.name.split('.').pop();
    this.setState({ fileName: file.name, extension });
    this.props.showVideoModal(true);
    videoUploadHandler && videoUploadHandler(file);
  };

   renderItemIcon = (extension: string) => {
    let imagePath = "";
    switch (extension) {
      case "xls":
      case "xlsx": {
        imagePath = "/assets/svg/excelDocIcon.svg";
        break;
      }
      case "doc":
      case "docx": {
        imagePath = "/assets/svg/wordDocIcon.svg";
        break;
      }
      case "pdf": {
        imagePath = "/assets/svg/pdfDocIcon.svg";
        break;
      }
      default:
        break;
    }
    return <img src={imagePath} height="40" width="30" alt={extension} />;
  };
  render() {
    const { classes } = this.props;
    const { isUpload, fileName, extension } = this.state;

    return ( fileName ?  <Grid container wrap="wrap" spacing={24} justify='center' className="paddingMD">
       <div className={classes.dragDropVideoContainer}>
            <Grid item xs={6} justify='center' >
              <Grid className={classes.itemContainer}>
                <CloseIcon
                  fontSize="small"
                  className={classes.closeIcon}
                  onClick={() => this.setState((prevState)=>({...prevState, fileName:''}))}
                />
               <Grid item xs={3}>
          {this.renderItemIcon(extension)}
        </Grid>
        <Grid item xs={9}>
          <Typography variant="subheading" className={classes.fileName}>
            {fileName}
          </Typography>
          <Typography variant="subtitle1" className={classes.extension}>
            {extension}
          </Typography>
        </Grid>
            </Grid>
            </Grid>
            </div>
      </Grid> : 
      <Grid container justify='center'>
        <div
          ref={(ref) => {
            this.wrapperRef = ref;
          }}
          className={classes.dragDropVideoContainer}
        >
          <Grid
            container
            justify='center'
            onDragOver={(event) => {
              event.preventDefault();
            }}
            onDrop={(event) => {
              event.preventDefault();
              this.readFile(event);
            }}
            style={
              !isUpload && document && document.activeElement && document.activeElement.id === 'inputForPaste'
                ? { opacity: 0.5 }
                : {}
            }
          >
            {!fileName && <div style={{ width: '100%' }}>
              <img
                alt='Cancel video upload'
                src="/assets/svg/learn/cloudUpload.svg"
                onClick={(e) => {
                  this.upload.value = '';
                  this.upload.click();
                }}
                style={{ cursor: 'pointer' }}
              />
            </div>}

            <Typography className={classes.dragDropVideoText} component='div' variant='body1' align='center'>
              {fileName ? (
                <div className={classes.fileTypeInfo}></div>
              ) : isUpload ? (
                'uploading'
              ) : (
                'Drag and drop an excel file to upload'
              )}
            </Typography>
            <input
              id='myInput'
              onChange={(event) => {
                this.readFile(event);
              }}
              type='file'
              ref={(ref) => (this.upload = ref)}
              style={{ display: 'none' }}
            />
            <input
              id='inputForPaste'
              type='text'
              ref={(ref) => (this.inputForPaste = ref)}
              onPaste={(event) => {
                this.readFile(event);
              }}
              style={{ opacity: 0, width: 0 }}
            />
          </Grid>
        </div>
      </Grid>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    openModal: state.showVideoModalReducers.openModal,
  };
}

const mapDispatchToProps = {
  showVideoModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(FileUploader));
